const cfg = {
  apiKey: "AIzaSyBR046smIiQUeRbBaErZWkgtdiMFmOlAlc",
  authDomain: "popout-c514d.firebaseapp.com",
  databaseURL: "https://popout-c514d.firebaseio.com",
  projectId: "popout-c514d",
  storageBucket: "popout-c514d.appspot.com",
  messagingSenderId: "629888312461",
  appId: "1:629888312461:web:01b195d11eafd8efab6ec4",
  measurementId: "G-FNHH927117"
}
export default cfg